import { createAction } from '@reduxjs/toolkit';
// 
import MixpanelEvents from 'app/features/mixpanel/MixpanelEvents';

// ToDO: needed only for `Page.store`
// since we do not migrate from saga to asyn functions
const handleCasePageUpdateConflict = createAction<{ documentId:number; pageNum:number }>(MixpanelEvents.CasePageUpdateConflict);
// End ToDO
const handleCaseEpisodeUpdateConflict = createAction<{ episodeId:number }>(MixpanelEvents.CaseEpisodeUpdateConflict);
const handleReportPresetOpened = createAction<{ presetId:number }>(MixpanelEvents.ReportPresetOpened);
const handleReportPresetSelected = createAction<{ presetId:number }>(MixpanelEvents.ReportPresetSelected);
const handleTemplateOpened = createAction<{ templateId:number }>(MixpanelEvents.TemplateOpened);
const handleAIChatConversationResponsePopupClick = createAction<{ messageId:string }>(MixpanelEvents.AIChatConversationResponsePopupClick);
const handleAIChatConversationResponsePopupPageClick = createAction<{ messageId:string; documentId:number; pageNum:number }>(MixpanelEvents.AIChatConversationResponsePopupPageClick);
const handleAIChatPromptClick = createAction<{ promptId:string }>(MixpanelEvents.AIChatPromptClick);
const handleAIChatPromptUse = createAction<{ promptId:string }>(MixpanelEvents.AIChatPromptUse);

const handleAIReferencedPageEditClick = createAction<{ documentId:number; pageNum:number }>(MixpanelEvents.AIReferencedPageEditClick);
const handleAIReferencedPageOpenClick = createAction<{ documentId:number; pageNum:number }>(MixpanelEvents.AIReferencedPageOpenClick);

const handleCaseWorkspaceSwitchToEpisodeViewClick = createAction(MixpanelEvents.CaseWorkspaceSwitchToEpisodeView);
const handleCaseWorkspaceSwitchToPagesViewClick = createAction(MixpanelEvents.CaseWorkspaceSwitchToPagesView);
const handleCaseWorkspaceSendToAIChatClick = createAction(MixpanelEvents.CaseWorkspaceSendToAIChat);

const handleCaseDocumentFocusModeEnterClick = createAction(MixpanelEvents.CaseDocumentFocusModeEnter);
const handleCaseWorkspaceFocusModeEnterClick = createAction(MixpanelEvents.CaseWorkspaceFocusModeEnter);

const handleEpisodeSuggestedAuthorClick = createAction<{ authorId:number; authorName:string; }>(MixpanelEvents.EpisodeSuggestedAuthorClick);

const handleCalendarEpisodePagePreviewOpen = createAction<{ documentId:number; pageNum:number; }>(MixpanelEvents.CalendarEpisodePagePreviewOpen);
const handleCalendarEpisodePageLinkOpen = createAction<{ documentId:number; pageNum:number; }>(MixpanelEvents.CalendarEpisodePageLinkOpen);

const handleCaseEpisodesViewClick = createAction(MixpanelEvents.CaseEpisodesView);
const handleCaseAuditLogViewClick = createAction(MixpanelEvents.CaseAuditLogView);
const handleCaseWorkflowsViewClick = createAction(MixpanelEvents.CaseWorkflowsView);
const handleCaseTemplatesViewClick = createAction(MixpanelEvents.CaseTemplatesView);

const handleCaseDocumentsNavBarOpenedClick = createAction(MixpanelEvents.CaseDocumentsNavBarOpened);
const handleCaseDocumentsNavBarClosedClick = createAction(MixpanelEvents.CaseDocumentsNavBarClosed);

type BulkActions = 'color' | 'tag' | 'workspace' | 'rotate' | 'aiChat' | 'export';

const handleCasePagesBulkActionClick = createAction<{ action:BulkActions; numberOfPages:number; }>(MixpanelEvents.CasePagesBulkAction);

const handleCasePagesSwitchToNewDesignClick = createAction(MixpanelEvents.CasePagesSwitchToNewDesign);
const handleCasePagesSwitchToOldDesignClick = createAction(MixpanelEvents.CasePagesSwitchToOldDesign);

const handleCaseReportPreviewOpenedClick = createAction<{ reportId:number }>(MixpanelEvents.CaseReportPreviewOpened);

const handleCaseDocumentCreatedClick = createAction<{ documentId:number }>(MixpanelEvents.CaseDocumentCreated);
const handleCaseDocumentDeletedClick = createAction<{ documentId:number }>(MixpanelEvents.CaseDocumentDeleted);

const handleCaseFloatingSearchOpened = createAction(MixpanelEvents.CaseFloatingSearchOpened);

const handleBillingInvoicesView = createAction(MixpanelEvents.BillingInvoicesView);
const handleSubscriptionsView = createAction(MixpanelEvents.SubscriptionsView);
const handleUsageReportView = createAction(MixpanelEvents.UsageReportView);
const handleCostExplorerView = createAction(MixpanelEvents.CostExplorerView);

const handleBillingInvoicesClientFilterClick = createAction<{ clientAccountId: number | null }>(MixpanelEvents.BillingInvoicesClientFilter);
const handleBillingInvoicesStatusFilterClick = createAction<{ status: string }>(MixpanelEvents.BillingInvoicesStatusFilter);
const handleBillingInvoicesSearchFilterClick = createAction<{ search: string }>(MixpanelEvents.BillingInvoicesSearchFilter);
const handleBillingInvoicesDateFilterClick = createAction<{ start: string | null, end: string | null }>(MixpanelEvents.BillingInvoicesDateFilter);
const handleBillingInvoicesCaseFilterClick = createAction<{ caseId: number | null }>(MixpanelEvents.BillingInvoicesCaseFilter);
const handleBillingInvoicesSelectAllVisibleClick = createAction(MixpanelEvents.BillingInvoicesSelectAllVisible);
const handleBillingInvoicesPDFExportClick = createAction<{ invoiceId: number }>(MixpanelEvents.BillingInvoicesPDFExport);
const handleBillingInvoicesACHPaymentClick = createAction<{ invoiceId: number }>(MixpanelEvents.BillingInvoicesACHPayment);
const handleBillingInvoicesCardPaymentClick = createAction<{ invoiceId: number }>(MixpanelEvents.BillingInvoicesCardPayment);
const handleBillingInvoicesBulkPDFExportClick = createAction<{ invoicesIds: number[] }>(MixpanelEvents.BillingInvoicesBulkPDFExport);
const handleBillingInvoicesBulkACHPaymentClick = createAction<{ invoicesIds: number[] }>(MixpanelEvents.BillingInvoicesBulkACHPayment);
const handleBillingInvoicesBulkCardPaymentClick = createAction<{ invoicesIds: number[] }>(MixpanelEvents.BillingInvoicesBulkCardPayment);

const handleCostExplorerBreakdownSwitchClick = createAction<{ breakdown: string }>(MixpanelEvents.CostExplorerBreakdownSwitch);
const handleCostExplorerClientFilterClick = createAction<{ clientAccountId: number | null }>(MixpanelEvents.CostExplorerClientFilter);
const handleCostExplorerSubscriptionFilterClick = createAction<{ subscriptionId: number | null }>(MixpanelEvents.CostExplorerSubscriptionFilter);
const handleCostExplorerServiceFilterClick = createAction<{ serviceId: number | null }>(MixpanelEvents.CostExplorerServiceFilter);
const handleCostExplorerCaseFilterClick = createAction<{ caseId: number | null }>(MixpanelEvents.CostExplorerCaseFilter);
const handleCostExplorerDateFilterClick = createAction<{ start: string | null, end: string | null }>(MixpanelEvents.CostExplorerDateFilter);
const handleCostExplorerShowAllInvoicesClick = createAction(MixpanelEvents.CostExplorerShowAllInvoices);
const handleCostExplorerInvoiceClick = createAction<{ invoiceNumber: string }>(MixpanelEvents.CostExplorerInvoiceClick);

const MixpanelActions = {
  handleCasePageUpdateConflict,
  handleCaseEpisodeUpdateConflict,
  handleReportPresetOpened,
  handleReportPresetSelected,
  handleTemplateOpened,
  handleAIChatConversationResponsePopupClick,
  handleAIChatConversationResponsePopupPageClick,
  handleAIChatPromptClick,
  handleAIChatPromptUse,

  handleCaseWorkspaceSwitchToEpisodeViewClick,
  handleCaseWorkspaceSwitchToPagesViewClick,
  handleCaseWorkspaceSendToAIChatClick,

  handleCaseFloatingSearchOpened,

  handleCaseDocumentFocusModeEnterClick,
  handleCaseWorkspaceFocusModeEnterClick,

  handleAIReferencedPageEditClick,
  handleAIReferencedPageOpenClick,

  handleEpisodeSuggestedAuthorClick,

  handleCalendarEpisodePagePreviewOpen,
  handleCalendarEpisodePageLinkOpen,

  handleCaseEpisodesViewClick,
  handleCaseAuditLogViewClick,
  handleCaseWorkflowsViewClick,
  handleCaseTemplatesViewClick,

  handleCaseDocumentsNavBarOpenedClick,
  handleCaseDocumentsNavBarClosedClick,

  handleCasePagesBulkActionClick,

  handleCasePagesSwitchToNewDesignClick,
  handleCasePagesSwitchToOldDesignClick,

  handleCaseReportPreviewOpenedClick,

  handleCaseDocumentCreatedClick,
  handleCaseDocumentDeletedClick,

  handleBillingInvoicesView,
  handleSubscriptionsView,
  handleUsageReportView,
  handleCostExplorerView,

  handleBillingInvoicesClientFilterClick,
  handleBillingInvoicesStatusFilterClick,
  handleBillingInvoicesSearchFilterClick,
  handleBillingInvoicesDateFilterClick,
  handleBillingInvoicesCaseFilterClick,
  handleBillingInvoicesSelectAllVisibleClick,
  handleBillingInvoicesPDFExportClick,
  handleBillingInvoicesACHPaymentClick,
  handleBillingInvoicesCardPaymentClick,
  handleBillingInvoicesBulkPDFExportClick,
  handleBillingInvoicesBulkACHPaymentClick,
  handleBillingInvoicesBulkCardPaymentClick,

  handleCostExplorerBreakdownSwitchClick,
  handleCostExplorerClientFilterClick,
  handleCostExplorerSubscriptionFilterClick,
  handleCostExplorerServiceFilterClick,
  handleCostExplorerCaseFilterClick,
  handleCostExplorerDateFilterClick,
  handleCostExplorerShowAllInvoicesClick,
  handleCostExplorerInvoiceClick
};

export default MixpanelActions;